import { render, staticRenderFns } from "./spreadEntity.vue?vue&type=template&id=57983661&"
import script from "./spreadEntity.vue?vue&type=script&lang=js&"
export * from "./spreadEntity.vue?vue&type=script&lang=js&"
import style0 from "./spreadEntity.vue?vue&type=style&index=0&id=57983661&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports